import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../reducers'

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAuthLoading = createSelector(selectAuthState,(state: AuthState) => state.loading);

export const selectAuthError = createSelector(selectAuthState,(state: AuthState) => state.error);

export const selectAuthForm = createSelector(selectAuthState,(state: AuthState) => state.authForm);

export const selectAuth = createSelector(selectAuthState,(state: AuthState) => state.auth);

export const selectRegistered = createSelector(selectAuthState,(state: AuthState) => state.registered);

export const selectUserForm = createSelector(selectAuthState,(state: AuthState) => state.userForm);

export const selectIsLoggedIn = createSelector(selectAuth, (auth) => !!auth);
